export default __webpack_public_path__ + "static/media/logo_tss.15e16777.svg";